/**
 * O aviso da emissão automática de NFS-e: UM texto (item 12 do lote coletado em 24/09/2026 ·
 * D-147 · DS-556).
 *
 * O fundador perguntou se os Provedores de NFS-e tinham função. Não têm: a emissão automática
 * não existe, e hoje a nota é registrada à mão em Faturamento. Ele decidiu manter o cadastro
 * com o aviso "ainda não desenvolvido", e o mesmo aviso vale para os dados fiscais de emissão
 * da Entidade DV. Por isso o texto é UM, e mora aqui: o catálogo Provedores de NFS-e o
 * declara no descritor (a 10.1 o desenha na lista e no modal), e a gaveta da 10.2 o desenha
 * em "Dados fiscais de emissão". Duas frases parecidas em dois lugares acabariam divergindo.
 *
 * Módulo próprio, e não `catalogos.ts` nem `entidades.ts`, porque os dois são editados ao
 * mesmo tempo por frentes diferentes; os dois importam daqui.
 *
 * O texto começa pelas palavras do fundador, diz onde a nota se registra hoje, e não usa
 * travessão nem o nome da versão (voz do produto: nenhuma tela fala em versão).
 */
export const AVISO_DA_EMISSAO_AUTOMATICA =
  'Ainda não desenvolvido. Estes dados servirão à emissão automática de NFS-e, que ainda não existe: hoje nenhum deles é usado, e a nota é registrada à mão em Faturamento.'
